module.exports = __webpack_public_path__ + "static/img/product_img_04.4e6f8da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_img_04.jpg
// module id = 90Vw
// module chunks = 0